// src/services/scenarioTrackingService.js
// REWRITTEN: All methods now use operationalScenariosService (post-W4 cleanup architecture)
// Previously called 4 deleted W4 routes (OperationalScenario model CRUD) that silently failed
import { loadCTIScenarios, deleteCTIScenario } from './operationalScenariosService';

const scenarioTrackingService = {
  async getScenariosForAttackPath(analysisId, attackPathId) {
    try {
      const result = await loadCTIScenarios(analysisId);
      const allScenarios = result.data?.scenarios || [];
      return allScenarios.filter(s => s.attackPathId === attackPathId);
    } catch (error) {
      console.error('[ScenarioTrackingService] Error fetching scenarios for attack path:', error);
      return [];
    }
  },

  async getScenarioStats(analysisId, attackPathId) {
    try {
      const result = await loadCTIScenarios(analysisId);
      const allScenarios = result.data?.scenarios || [];
      const matching = allScenarios.filter(s => s.attackPathId === attackPathId);
      return { totalScenarios: matching.length, attackPathId };
    } catch (error) {
      console.error('[ScenarioTrackingService] Error fetching scenario stats:', error);
      return { totalScenarios: 0, attackPathId };
    }
  },

  async getNextGenerationAttempt(analysisId, attackPathId) {
    try {
      const result = await loadCTIScenarios(analysisId);
      const allScenarios = result.data?.scenarios || [];
      const count = allScenarios.filter(s => s.attackPathId === attackPathId).length;
      return count + 1;
    } catch (error) {
      console.error('[ScenarioTrackingService] Error fetching next generation attempt:', error);
      return 1;
    }
  },

  async deleteScenario(analysisId, scenarioId) {
    try {
      return await deleteCTIScenario(analysisId, scenarioId);
    } catch (error) {
      console.error('[ScenarioTrackingService] Error deleting scenario:', error);
      throw error;
    }
  },
};

export default scenarioTrackingService;